
const digest = '60ed1c8d0a25d585bbc70e10932537ee7d9afd1553f6876100036d480a9b9c2d';
const classes = {"wrapper":"_wrapper_5a9hi_1","options":"_options_5a9hi_9","list":"_list_5a9hi_19"};
const css = `._wrapper_5a9hi_1 {
  font-family: "Rubik", sans-serif;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
}
._wrapper_5a9hi_1 ._options_5a9hi_9 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  padding: 16px 24px;
  border: 1px solid #eaedf3;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  border-top: 0;
}
._wrapper_5a9hi_1 ._list_5a9hi_19 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: scroll;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
}
._wrapper_5a9hi_1 ._list_5a9hi_19::-webkit-scrollbar {
  display: block;
}
._wrapper_5a9hi_1 ._list_5a9hi_19::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  padding: 2px;
}
._wrapper_5a9hi_1 ._list_5a9hi_19::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._wrapper_5a9hi_1 ._list_5a9hi_19::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_5a9hi_1 ._list_5a9hi_19::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  